import { render, staticRenderFns } from "./CreateNewCreditReportDrawer.vue?vue&type=template&id=f4c0c27c"
import script from "./CreateNewCreditReportDrawer.vue?vue&type=script&lang=js"
export * from "./CreateNewCreditReportDrawer.vue?vue&type=script&lang=js"
import style0 from "./CreateNewCreditReportDrawer.vue?vue&type=style&index=0&id=f4c0c27c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports